import {
  Logo,
  TwitterIcon,
  FacebookIcon,
  LinkedInIcon,
  DiscordIcon
} from '../../assets/svg';
import {
  Container,
  LogoContainer,
  SocialLinksAndSignUpButtonContainer,
  SignUpButton,
  Link
} from './Header.style';
import { useAuth0 } from '@auth0/auth0-react';

export const Header = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  return (
    <Container>
      <LogoContainer>
        <Logo onClick={() => window.open('/', '_self')} />
      </LogoContainer>
      <SocialLinksAndSignUpButtonContainer>
        <Link
          onClick={() => window.open('https://docs.roundpe.com/', '_blank')}
        >
          Docs
        </Link>
        <Link
          onClick={() =>
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSfzac7nMjDdQGgzymaT0p7sBZc2ztDG2LD7OLcI5tuDoZwrbA/viewform',
              '_blank'
            )
          }
        >
          Request a Demo
        </Link>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://discord.gg/WxgRXcFfSe"
        >
          <DiscordIcon />
        </a>
        <a target="_blank" rel="noreferrer" href="https://twitter.com/0xRound">
          <TwitterIcon />
        </a>
        {/* <a href="#">
          <FacebookIcon />
        </a> */}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/company/round-finance-inc/about/"
        >
          <LinkedInIcon />
        </a>
        {!isAuthenticated && (
          <SignUpButton onClick={() => loginWithRedirect()}>
            Sign up
          </SignUpButton>
        )}
      </SocialLinksAndSignUpButtonContainer>
    </Container>
  );
};
